import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { IncTextFieldProps } from 'components/forms/fields/inc-text-field/inc-text-field.component';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { FieldError } from 'react-hook-form';

type CustomTextFieldProps = {
  handleIncrement?: () => void;
  handleDecrement?: () => void;
  dDisabled?: boolean;
  iDisabled?: boolean;
  allowDecimal?: boolean;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  helperText?: string;
  error?: FieldError;
} & IncTextFieldProps;

export const CustomTextField = ({
  handleIncrement,
  handleDecrement,
  dDisabled,
  iDisabled,
  allowDecimal,
  value,
  onChange,
  error,
  helperText,
  ...rest
}: CustomTextFieldProps) => {
  return (
    <TextField
      {...rest}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={<IncFormHelperText error={error} helperText={helperText} />}
      sx={{ input: { textAlign: 'center' }, ...rest.sx }}
      onKeyDown={e => {
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (!iDisabled) handleIncrement?.();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (!dDisabled) handleDecrement?.();
        } else if (!allowDecimal && e.key === '.') {
          e.preventDefault();
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton
              size="small"
              data-testid="NumericStepInput.Decrement"
              onClick={handleDecrement}
              tabIndex={-1}
              color="primary"
              disabled={dDisabled}
            >
              <RemoveIcon />
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              data-testid="NumericStepInput.Increment"
              onClick={handleIncrement}
              tabIndex={-1}
              color="primary"
              disabled={iDisabled}
            >
              <AddIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
